import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'
import Icon from '../../../util/Icon'
import WelcomeAction from './action'

@inject('welcome')
@observer
export default class Welcome extends Component {

  handleSkip = action => event => {
    event.preventDefault()
    this.props.welcome.update(action.key)
  }

  handleSkipAll = event => {
    event.preventDefault()
    this.props.welcome.markAll()
  }

  actionLink(action) {
    if (action.path) {
      return (
        <Link className="primary button" to={this.props.welcome.getActionLinkUrl(action)}>Update</Link>
      )
    }
  }

  render() {
    const { welcome } = this.props
    return (
      <div className="container padded welcome">
        <div className="panel full padded">
          <div className="welcome-header">
            <h2 className="title">Welcome to Showcase IDX!</h2>
            { welcome.progress < 1 ? (
              <p>Let's get your IDX set up and you on your way!</p>
            ) : null}
            <p>Progress: {Math.round(welcome.progress*100)}% Complete</p>
            { welcome.progress === 1 ? (
              <div className="welcome-complete">
                <div className="welcome-success">
                  <Icon icon="check-circle" />
                  You're All Set!
                </div>
                <p>
                  You can always return to this checklist by clicking the
                  Welcome Screen link at the bottom of the Settings dropdown.
                </p>
                <Link className="button" to={`/website/${welcome.website.id}/leads`}>Continue</Link>
              </div>
            ) : null}
          </div>

          <div>
            {welcome.actions.map(action => (
              <WelcomeAction
                key={action.key}
                {...action}>
                <a className="skip button" href="#" onClick={this.handleSkip(action)}>Skip</a>
                {this.actionLink(action)}
              </WelcomeAction>
            ))}
          </div>

          <div className="welcome-skip-all">
            <a href="#" onClick={this.handleSkipAll}>Skip All</a>
          </div>

          <div>
            <WelcomeAction
              icon='desktop'
              label='Watch tutorial videos that show you how to use Showcase IDX'
              description='All of our tutorials in one place that you can always go back to'>
              <a className="primary button" href="https://showcaseidx.com/video-tutorials" target="_blank">Open</a>
            </WelcomeAction>
            <WelcomeAction
              icon='question'
              label='Still have questions?'
              description='Just ask! We’re here to help answer any question you might have about Showcase IDX'>
              <a className="primary button" href="mailto:help@showcaseidx.com" target="_blank">Open</a>
            </WelcomeAction>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Welcome/index.js